// extracted by mini-css-extract-plugin
module.exports = {"avatarsRow":"OperatorsList_avatarsRow__2ybOp","addButton":"OperatorsList_addButton__312Mo","opsList":"OperatorsList_opsList__oQ_eM"};